export default __webpack_public_path__ + "static/media/pic1.ac173f78.jpg";